import React from "react";
import { normalizeClassName } from "../../render/renderUtils";

export function TrackHeader({
    children,
}: {
    children?: React.ReactNode,
}) {
    return (<div className="piano-roll-header-info-bar">
        <div className={normalizeClassName(["piano-roll-header-controls", 'header-controls'])}>
            {children}
        </div>
    </div>);
}